
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"actualizarAdjudicacionDirecta"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"adjudicacionDirecta"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"inputAdjudicacionDirecta"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actualizarAdjudicacionDirecta"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"adjudicacionDirecta"},"value":{"kind":"Variable","name":{"kind":"Name","value":"adjudicacionDirecta"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idContratista"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contratista"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombreRazonSocial"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombreRepresentante"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"numeroContrato"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"meta"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numeroDictamen"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fecha"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"importe"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"porcentajeIva"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"iva"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"total"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"porcentajeAnticipo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaInicio"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaTermino"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plazo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"obras"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idAdjudicacionDirecta"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idObra"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"obra"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clave"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"meta"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"importe"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"porcentajeIva"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"iva"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"total"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":687}};
    doc.loc.source = {"body":"mutation actualizarAdjudicacionDirecta(\n  $id: ID!\n  $adjudicacionDirecta: inputAdjudicacionDirecta!\n) {\n  actualizarAdjudicacionDirecta(id: $id, adjudicacionDirecta: $adjudicacionDirecta) {\n    id\n    idContratista\n    contratista {\n      id\n      nombreRazonSocial\n      nombreRepresentante\n    }\n    numeroContrato\n    meta\n    numeroDictamen\n    fecha\n    importe\n    porcentajeIva\n    iva\n    total\n    porcentajeAnticipo\n    fechaInicio\n    fechaTermino\n    plazo\n    obras {\n      id\n      idAdjudicacionDirecta\n      idObra\n      obra {\n        id\n        clave\n        meta\n      }\n      importe\n      porcentajeIva\n      iva\n      total\n    }\n    createdAt\n    updatedAt\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["actualizarAdjudicacionDirecta"] = oneQuery(doc, "actualizarAdjudicacionDirecta");
        
